import { Route, Routes } from "react-router-dom";
import AdministrateursPage from "../screens/refonte/admin/administrateurs/AdministrateursPage";
import AssociationsMembersPage from "../screens/refonte/admin/association/AssociationsMembersPage";
import AssociationsPage from "../screens/refonte/admin/association/AssociationsPage";
import DashboardPage from "../screens/refonte/admin/dashboard/DashboardPage";
import AppGuid from "../screens/refonte/admin/guide/forms/AppGuid";
import SousDomainePage from "../screens/refonte/admin/parametrage/AMI/domaine_sous_domaine/SousDomainePage";
import SQCFormPage from "../screens/refonte/admin/parametrage/AMI/sqc_formulaire/SQCFormPage";
import SQCFormQuestionPage from "../screens/refonte/admin/parametrage/AMI/sqc_formulaire/SQCFormQuestionPage";
import ParametragePage from "../screens/refonte/admin/parametrage/ParametragePage";
import AgexPage from "../screens/refonte/admin/recrutement/agex/AgexPage";
import ConsultantPage from "../screens/refonte/admin/recrutement/consultant/ConsultantPage";
import RecrutementPage from "../screens/refonte/admin/recrutement/RecrutementPage";
import VolontariatPage from "../screens/refonte/admin/recrutement/volontariat/VolontariatPage";
import Forbiden from "../screens/refonte/Forbiden";
import NotFound from "../screens/refonte/NotFound";
import Profile from "../screens/refonte/profile/Profile";
import { AuthProvider, useAuth } from "./AuthContext";

const AdminRoutes = () => {
  const isAuthenticated = useAuth(); // localStorage.getItem("token") !== null;
  const current_url = window.location.href;
  const is_administration = current_url.split("/")[3] === "administration";
  
  return (
    <>
      {/* <Routes basename="/cv_candidature"> */}
      <AuthProvider>
        {/* <BrowserRouter> */}
        <Routes  basename={""}>
          <Route path="403" element={<Forbiden />} />
          <Route path="404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
          {/**Route pour l'administration */}
          <Route path="administration">
            <Route path="" element={<AssociationsPage />} />
            <Route path="mon-profile" element={<Profile />} />

            {/** Temporairement caché */}
            <Route path="dashboard">
              <Route path="" element={<DashboardPage />} />
            </Route>
            <Route path="recrutement">
              <Route path="" element={<RecrutementPage />} />
              <Route path="volontariat">
                <Route path="" element={<VolontariatPage />} />
                <Route
                  path="agence-membres"
                  element={<AssociationsMembersPage />}
                />
              </Route>
              <Route path="agex">
                <Route path="" element={<AgexPage />} />
                <Route
                  path="agence-membres"
                  element={<AssociationsMembersPage />}
                />
              </Route>
              <Route path="consultant" element={<ConsultantPage />} />
            </Route>
            <Route path="agences-gerees">
              <Route path="" element={<AssociationsPage />} />
              <Route path="membres" element={<AssociationsMembersPage />} />
            </Route>
            <Route path="parametrage">
              <Route path="" element={<ParametragePage />} />
              <Route path="formulaire">
                <Route path="" element={<SQCFormPage />} />
                <Route path="questions" element={<SQCFormQuestionPage />} />
                <Route path="sous-domaine" element={<SousDomainePage />} />
              </Route>
            </Route>
            <Route path="administrateurs">
              <Route path="" element={<AdministrateursPage />} />
            </Route>
            <Route path="help">
              <Route path="" element={<AppGuid />} />
            </Route>
          </Route>

          {/**Route pour l'administration */}
        </Routes>
        {/* </BrowserRouter> */}
      </AuthProvider>
    </>
  );
};

export default AdminRoutes;
